module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMO20un///+py+WFtdp4rdZgns7z+PtUl8tHj8fa6fS/016HAAAACHRSTlMAYL//ACDP71kzCuAAAADfSURBVHgB7dhLCsMwDITh8TN23rn/Zat0UyiCTGstSur/AN/KEWRw5nxoyLsoIcaUQ2M5nVAaQnNDEigHg3KECyY5eBvIIxj1Y1CHSrGBSq2EBMKRxnZoqs+mVkgcTgLnSHMLtKwvaF14SHNYCbQj0vYdtB/1rWPnIMXhJfDO2fE5VKpaYSDF4SUQDiXh4kErTQSkOKwEwqEkqA9a6epjAeFQEgiHkkA9aOJjAeFQEkhHkfrN7je732yt8dY3e771zd5ufbP3/pvVoT+AzEYWs9nHaogym8YsxzrJYj58ACJVWblrQWr9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/23eb.png
// module id = 1329
// module chunks = 0